/**
 * A function to generate a collection of css variable tokens, abstracted for general use
 * from code in createTokenInjector.tsx
 */
export const getCSSVariables = (namespace, themeKey, tokens) => {
  // Create 2 things:
  // 1) a set of css custom properties to pass along to the injector
  const cssCustomProperties = {};
  // 2) a dictionary of token names => the CSS custom property names from #1.
  const tokenNameLookup = {};
  for (const token of tokens) {
    const tokenVariableName = `--smar--${namespace}--${token["name"]}`;
    // insert the variable name into the by-token-name lookup table.
    tokenNameLookup[token.name] = tokenVariableName;
    if (token.value[themeKey]) {
      // Insert the css custom property into the map for the DOM.
      cssCustomProperties[tokenVariableName] = token.value[themeKey];
    }
  }
  return cssCustomProperties;
};
//# sourceMappingURL=getCSSVariables.js.map